<template>
  <div class="video" v-if="status">
    <div class="left">
      <div class="input">
        <el-input size="small" style="width: 150px" placeholder="请输入关键字" clearable v-model="searchText" prefix-icon="el-icon-search" @clear="clear"></el-input>
        <el-button size="small" class="btn" @click="search">搜索</el-button>
      </div>
      <div class="box">
        <div class="font">
          <img class="videlImg" src="@/assets/img/video.png" alt="" />
          <span class="fontss">监控地址</span>
        </div>
        <hr style="margin-top: 5px" />
        <div class="boxPos">
          <el-checkbox-group v-model="checkedVideos" @change="openvideo($event)" :key="videoKey" :max="4">
            <el-checkbox v-for="(item, key) in list" :label="item" :key="key" border>
              <font style="font-size: 13px">{{ item.v_video_address }}</font>
            </el-checkbox>
          </el-checkbox-group>
          <!-- <li class="box-content" v-if="list.length == 0">
            暂无数据
          </li> -->
          <Empty v-if="list.length == 0"></Empty>
        </div>
      </div>
    </div>
    <div class="right">
      <el-row :gutter="10">
        <el-col :span="10" v-for="(item, index) in checkedVideos" :key="index" class="mt20 relative">
          <template v-if="index <= 4">
            <div class="" v-if="item.isonly == 1">
              <div style="height: 330px">
                <!-- <video muted autoplay width="500px" height="250px" src="http://cmgw-vpc.lechange.com:8888/LCO/9F0C696PAG00008/0/1/20231016T071943/d320dda58592c5b28d302744f7ae2c2d.m3u8"></video> -->
                <!-- <video muted autoplay width="500px" height="250px" src="https://open.imou.com/liveH5/live?uuid=55cb7d213f58414cba778bc67107a3dd"></video> -->
                <iframe :src="`https://open.ys7.com/ezopen/h5/iframe?url=${item.vUrl}`" width="100%" height="100%" allowfullscreen> </iframe>
                <!-- <video id="hlsVedio" class="video-js vjs-default-skin"
                    controls
                    data-setup="{}"
                    preload="auto"
                    width="500px"></video> -->
                <!-- <video-player
      ref="videoPlayer"
      :options="videoOptions"
      class="vjs-custom-skin videoPlayer"
      :playsinline="true"
   /> -->
                <!-- <div>
                  <video
                    id="my-video"
                    class="video-js vjs-default-skin"
                    controls
                    preload="auto"
                    width="500px"
                  >
                    <source
                      :src="attachmentLink"
                     
                    />
                  </video>
                </div> -->
                <!-- <div id="id_test_video" style="width:100%; height:auto;"></div> -->

                <!-- <div ref="videoContainer" style="width: 850px;height: 500px;">
                <video style="width: 100%;height: 100%;" ref="videoPlayer" class="video-js"></video>
                </div> -->
              </div>
            </div>
            <div v-else @click="handlePlay(item, index)" class="cursor" style="height: 330px; position: relative; border: 1px solid #ccc">
              <cus-player :ref="'video' + item.uuid" style="width: 100%" :id="'video' + item.uuid"></cus-player>
            </div>
            <div class="align-center mt10">
              <span>监控ip：</span>
              {{ item.v_video_ip }}
              <!-- <el-input class="ml10 flex1" size="mini" v-model=""></el-input> -->
            </div>
            <div class="align-center mt10">
              <span>监控地址：</span>
              <span>{{ item.v_video_address }}</span>
              <!-- <el-input class="ml10 flex1" size="mini" v-model=""></el-input> -->
            </div>
            <div class="align-center mt10 fang" v-show="item.isonly == 1">
              <span>操控方向：</span>
              <!-- <el-input class="ml10 flex1" size="mini" v-model="item.v_video_address"></el-input> -->
              <div class="ml10 flex1 flex align-center" style="height: 100px">
                <div style="height: 70%; width: 100px; position: relative" class="center flex">
                  <el-button style="position: absolute; top: 2px; left: 45px;" type="primary" @click="turn(item, 0)" circle>↑</el-button>
                  <el-button type="primary" style="position: absolute; bottom: 2px" circle @click="turn(item, 1)">↓</el-button>
                  <el-button type="danger" size="mini" style="position: absolute;left: 42px; text-algin: center" @click="turn(item, 1, true)">停</el-button>
                  <el-button type="primary" style="position: absolute; left: 10px" @click="turn(item, 2)" circle>←</el-button>
                  <el-button type="primary" style="position: absolute; right: 12px" @click="turn(item, 3)" circle>→</el-button>
                </div>
              </div>
            </div>
          </template>
          <!-- <iframe :src="'https://open.ys7.com/ezopen/h5/iframe_se?url='+item.vUrl" width="400" height="400" frameborder="0" allowfullscreen ></iframe> -->
          <!-- <video width="400" height="200" :src="'https://open.ys7.com/ezopen/h5/iframe_se?url='+item.vUrl" controls></video> -->
        </el-col>
      </el-row>
    </div>
    <div class="vides" v-if="!checkedVideos.length">请选择监控地址</div>
  </div>
</template>
<script>
import { getVideo } from '@/api/facility';
import CusPlayer from '@/components/CusPlayer.vue';
import config from '@/utils/config';
// import flvjs from "flv.js";
// import Hls from 'hls.js';
// import "video.js/dist/video-js.css";
// // import videojs from "video.js";
// // import "videojs-contrib-hls";
// // import 'video.js/dist/video-js.css';
//   // import 'vue-video-player/src/custom-theme.css'
//   //引入hls.js
//   // import 'videojs-contrib-hls'
//   // video-player
//   // import { videoPlayer } from 'vue-video-player'
//   import VideoPlayer from "vue-video-player";
//     // require("video.js/dist/video-js.css");
//     import 'video.js'
//     import 'videojs-flash'
//     import hls from "videojs-contrib-hls";
//     import Vue from "vue";
//     Vue.use(hls)
//     Vue.use(VideoPlayer)
export default {
  props: ['cpNum'],
  data() {
    return {
      list: [],
      searchText: '',
      checkedVideos: [],
      videoKey: 0,
      checked: null,
      videoArray: [],
      status: false,
      isonly: false,
      // options: {
      //   autoplay: true, // 设置自动播放
      //   width: "440", // 视频框宽度
      //   height: "264", // 视频框高度
      //   // muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音（Chrome66及以上版本，禁止音视频的自动播放）
      //   preload: "auto", // 预加载
      //   controls: true, // 显示播放的控件
      // },
      // attachmentLink:
      //   "http://cmgw-vpc.lechange.com:8888/LCO/9F0C696PAG00008/0/1/20231016T071943/d320dda58592c5b28d302744f7ae2c2d.m3u8",
      //   videoOptions: {
      //   playbackRates: [0.5, 1.0, 1.5, 2.0], // 播放速度
      //   autoplay: false, // 自动播放
      //   muted: false, // 静音
      //   loop: false, // 循环播放
      //   preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      //   language: "zh-CN",
      //   aspectRatio: "16:9", // 值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      //   techOrder: ["html5", "flash"], // 兼容顺序
      //   sources: [
      //     {
      //       type: "application/x-mpegURL",
      //       src: "http://cmgw-vpc.lechange.com:8888/LCO/9F0C696PAG00008/0/1/20231016T071943/d320dda58592c5b28d302744f7ae2c2d.m3u8",
      //       // type: "rtmp/hls",
      //       // src: "rtmp://www.dsf.com/livetv",
      //     },
      //   ],
      //   hls: true,
      // }
    };
  },
  components: {
    CusPlayer,
  },
  computed: {
    havevideo() {
      return !this.list.length;
    },
  },
  mounted() {
    // console.log(22222222);
    // this.$post('https://openapi.lechange.cn/openapi/getKitToken',{
    //   token:'9e12dc40285f43d1972abb53213236',
    //   deviceId:'9F0C696PAG00008',
    //   channelId:'0',
    //   type:'0'
    // }).then(res=>{
    //   console.log(res,111111111);
    // }).catch(error=>{
    //   console.log(error,3333);
    // })
    if (this.cpNum) this.getList();
  },
  watch: {
    cpNum() {
      this.getList();
      this.checkedVideos = [];
    },
    search() {
      if (!this.searchText) {
        this.list = [];
        return;
      }
    },
  },
  methods: {
    getList() {
      this.$get('basevideo/videotoken').then((Res) => {
        if (Res.code == 200) {
          this.token = Res.data;
          getVideo({ c_company_num: this.cpNum }).then((res) => {
            var arr = [];
            if (res.data.length) {
              this.status = true;
              if (this.cpNum) {
                var arr = [];
                res.data.map((item) => {
                  if (item.v_video_ip === 'J53116250') {
                    arr.push(item);
                  }
                });
                this.list = res.data;
              } else {
                this.list = arr;
              }

              this.list.map((item, index) => {
                if (item.isonly == 1) {
                  item.vUrl = `ezopen://open.ys7.com/${item.v_video_ip}/1.live&accessToken=${Res.data}`;
                  item.turn = 0;
                } else {
                  item.vUrl = `${item.v_video_url ? item.v_video_url + '/live' : config.camraWs}?url=${item.url}`;
                  // item.vUrl='http://439095z89z.oicp.vip:8866/live?url=rtsp://admin:123456abc@192.168.0.202:554/h264/ch1/main/av_stream'
                  // console.log(encodeURI(item.vUrl), '5555555555');
                  item.turn = 'disabled';
                  item.isPlay = false;
                  // item.checked = true; // 选中状态
                }
                item.uuid = item.v_video_ip.replaceAll('.', '_');
              });
            } else {
              this.list = [];
              this.status = false;
              return this.$message.warning('该业务尚未开通，请联系管理员');
            }
            console.log(this.list);
          });
        }
      });
    },
    handlePlay(item, index) {
      log(item, index, '点击播放获取数据');
      if (item.isPlay == false) {
        if (item.vUrl) {
          console.log(item.vUrl, 'item.vUrl');
          let ref = 'video' + item.uuid;
          setTimeout(() => {
            this.$refs[ref][0].createPlayer(item.vUrl, false, index);
            // this.$refs[ref][0].createPlayer(
            //   "https://e-sign.dms.t.cn-np.com/files/m3u8_file/c4b94118-3c8d-4410-9987-985c2b44c278/c4b94118-3c8d-4410-9987-985c2b44c278.m3u8",
            //   false,
            //   index
            // );
            item.isPlay = true;
            if (item.checked == false) {
            }
          }, 10);
          // this.$refs[ref].createPlayer(this.playUrl, true, this.videoIndex);
        } else {
          return;
        }
      }
    },
    turn(it, direction, stop) {
      //  console.log(it.turn)
      var obj = {
        accessToken: this.token,
        deviceSerial: it.v_video_ip,
        channelNo: 1,
        direction,
        speed: 1,
      };
      if (!stop) {
        this.$post(`basevideo/stoprotatevideo`, obj).then((res) => {
          this.$post(`basevideo/rotatevideo`, obj);
        });
      } else {
        this.$post(`basevideo/stoprotatevideo`, obj).then((res) => {});
      }
    },
    openvideo(item) {
      //    videojs(
      //   "my-video",
      //   {
      //     bigPlayButton: false,
      //     textTrackDisplay: false,
      //     posterImage: true,
      //     errorDisplay: false,
      //     controlBar: true,
      //   },
      //   function () {
      //     this.play();
      //   }
      // );

      // this.attachmentLink=''
      // console.log(this.options, "video options");
      //  videojs("my-video", this.options);
      //    const video = document.getElementById('hlsVedio');
      // if (Hls.isSupported()) {
      //   const hls = new Hls();
      //   console.log(1);
      //   this.hls = hls;
      //   console.log(2);
      // var player = new TcPlayer('id_test_video', {
      //                 "m3u8": "http://cmgw-vpc.lechange.com:8888/LCO/9F0C696PAG00008/0/1/20231016T071943/d320dda58592c5b28d302744f7ae2c2d.m3u8", //请替换成实际可用的播放地址
      //                 "autoplay" : true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
      //                 // "poster" : "http://www.test.com/myimage.jpg",
      //                 "width" : '640',//视频的显示宽度，请尽量使用视频分辨率宽度
      //                 "height" : '480'//视频的显示高度，请尽量使用视频分辨率高度
      //                 });
      //   hls.loadSource('http://cmgw-vpc.lechange.com:8888/LCO/9F0C696PAG00008/0/1/20231016T071943/d320dda58592c5b28d302744f7ae2c2d.m3u8');
      //   hls.attachMedia(video);
      //   hls.on(Hls.Events.MANIFEST_PARSED, function() {
      //     video.play();
      //   });
      // } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      //   video.src = 'http://cmgw-vpc.lechange.com:8888/LCO/9F0C696PAG00008/0/1/20231016T071943/d320dda58592c5b28d302744f7ae2c2d.m3u8';
      //   video.addEventListener('loadedmetadata', function() {
      //     video.play();
      //   });
      // }

      this.$nextTick(() => {
        this.checkedVideos.forEach((item) => {
          let ref = 'video' + item.uuid;
          // console.log(ref, this.$refs[ref]);
          if (this.$refs[ref] && this.$refs[ref].length) {
            this.$refs[ref][0].changeVideo(item.vUrl);
          }
        });
      });
      // log(item, "选择视频  数据+");
      // this.checked = item.map((item) => {
      //   return { checked: false };
      // });
      // log(this.checked);
      // if (this.checked == false) {
      // }
      // this.videoKey+++
      this.checkedVideos.splice(4);
      if (this.checkedVideos.length >= 4) {
        this.$message.warning('最多可以选择四个摄像头查看');
      }

      this.list.forEach((item) => {
        if (!this.checkedVideos.some((it) => it.uuid == item.uuid)) {
          item.isPlay = false;
        }
      });

      // 显示
    },
    getvide() {},
    // 搜素单位
    search() {
      let text = this.searchText;
      let reg = new RegExp(text); //声明正则变量
      this.list = this.list.filter((item) => reg.test(item.v_video_address)); //返回
    },
    clear() {
      this.getList();
      this.checkedVideos = [];
    },
  },
};
</script>
<style scoped lang="scss">
.mt20 {
  padding-top: 0px !important;
  margin: 2px;
}
.vides {
  font-size: 16px;
  color: #999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-60%, -50%);
}
.el-row {
  padding-top: 0 !important;
}
.center .flex {
  width: 80%;
  height: 6.25rem;
}

.video {
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;

  .left {
    width: 16%;
    display: flex;
    flex-direction: column;
    .input {
      display: flex;
    }
    .font {
      padding-top: 7px;
      padding-left: 25%;
      // 监控地址
      .fontss {
        font-size: 16px;
        // padding-bottom: 0.3125rem;
        margin-left: 0.3125rem;
        color: #000;
      }
      // 图标
      .fonts {
        font-size: 40px;
      }
    }
    .btn {
      margin-left: 10px;
    }
    // 选择的视频地址的盒子
    .box {
      max-width: 14.375rem;
      min-width: 7.5rem;
      max-height: 75vh;
      border: 1px solid #cfcdcd;
      margin-top: 4.8px;
      display: flex;
      flex-direction: column;
      overflow: auto;
      border-radius: 10px;

      .boxPos {
        // width: 100% !important;
        display: flex;
        justify-content: center;
        text-align: center;
        display: flex;
        overflow: auto;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .el-row {
    min-width: 80vw;
    max-height: 100vh;
    position: relative;
    // left: 3%;
    left: 3.125rem;
    .fang {
      position: absolute;
      top: 19rem;
      left: 23%;
      .el-button {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }
}
.el-checkbox {
  margin-right: 0px;
}
::v-deep .el-checkbox-group {
  display: grid;
  flex-direction: column;
  grid-gap: 5px;
  padding: 5px 10px;
  max-height: calc(100% - 300px);
}
::v-deep .el-checkbox__input {
  float: right;
  margin-left: 110px;
}
.videlImg {
  width: 20px;
  height: 20px;
}

.right {
  max-height: 80vh;
  position: relative;
}
</style>
